import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WorkspaceContextService } from '../services/workspace-context.service';
import { isDelegateRestrictedPath } from '../utils/delegate-restricted-routes.util';

export const delegateRestrictedRouteGuard: CanActivateFn = (_route, state) => {
  const workspace = inject(WorkspaceContextService);
  if (!workspace.isDelegateSession() || !isDelegateRestrictedPath(state.url)) {
    return true;
  }

  const delegated = workspace.getActiveDelegatedWorkspace();
  const home = delegated ? workspace.panelRouteFor(delegated) : '/';
  return inject(Router).parseUrl(home);
};
